import PublicRoute from './Public/Public';
// import PrivateRoute from "./Private/Private"
import PAGES from './Pages';

const routes = [
    {
        path: '/',
        element: <PublicRoute />,
        children: PAGES().PUBLIC_PAGES,
    },
    // {
    //     path: '/',
    //     element: <PrivateRoute />, 
    //     children: PAGES().PRIVATE_PAGES,
    // },
];

export default routes;
